<template>
  <div class="block31">
    <!-- 返回 -->
    <div class="return">
      <router-link to="/">
        <span class="arrow"></span>返回首页
      </router-link>
    </div>
    <!-- 返回 -->
    <!-- 内容 -->
    <div class="container">
      <h2 class="title1">警告指示灯点亮</h2>
      <div class="container-content">
        <p class="text_line">电喷故障指示灯</p>
        <p>
         如果在驾骑过程中此指示灯点亮，您的摩托车程序控制燃油喷射系统可能存在问题。请减速，并尽快交由本田特约维修店检修摩托车。
        </p>
       
        <p class="text_line">ABS（防抱死制动系统）指示灯</p>
        <p>如果指示灯出现下列任何一种情况，说明您的制动系统出现问题。请减速，并尽快交由本田特约维修店检修摩托车。</p>
        <ul class="circle">
          <li>
           骑乘时指示灯点亮或开始闪烁。
          </li>
          <li>当点火开关处于ON（开）位置时，指示灯不亮。</li>
          <li>
            速度高于10千米/小时时，指示灯不熄灭。
          </li>
        </ul>
        <p>
          如果ABS指示灯仍然常亮，您的制动系统将按常规模式工作，但不具备防抱死功能。
        </p>
        <p class="text_line">燃油表故障指示</p>
        <p>
          如果燃油系统有一个错误，燃油表指示器将按图示显示。<br>如果发生这种情况，尽快通知您的经销商。</p>
        <img src="./img/img2.jpg" width="100%">
        <img src="./img/img3.jpg" width="100%">
        
      </div>
      <div class="foot-btn">
        <div class="prev">
          <router-link to="/block30">上一页</router-link>
        </div>
        <div class="next">
          <router-link to="/block32">下一页</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["id"],
  watch: {'$route'(to, from) {if(this.id != null) {setlink(this.id);}}},
  mounted() {
    setlink(this);

  },
  methods: {
    goto(path) {this.$router.push({ path: path });}
  }
};
</script>